// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './contexts/AuthContext';
import { AdminOverrideProvider } from './contexts/AdminOverrideContext';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import { SelectedStateProvider } from './contexts/SelectedStateContext';
import { ErrorBoundary } from './ErrorBoundary';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from './queryClient';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
    <HelmetProvider>
    <ErrorBoundary>
      <BrowserRouter>
        {/* SelectedStateProvider sits outside AuthProvider so the selected
            state is available immediately — before any auth fetches complete.
            This prevents the mobile race condition where the "/" route renders
            with DEFAULT_STATE before localStorage is read by child components. */}
        <SelectedStateProvider>
          <AuthProvider>
            {/* AdminOverrideProvider must wrap SubscriptionProvider so that
                SubscriptionContext can consume the override state. */}
            <AdminOverrideProvider>
              <SubscriptionProvider>
                <App />
              </SubscriptionProvider>
            </AdminOverrideProvider>
          </AuthProvider>
        </SelectedStateProvider>
      </BrowserRouter>
    </ErrorBoundary>
    </HelmetProvider>
    {process.env.NODE_ENV !== 'production' && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  </React.StrictMode>
);

reportWebVitals();
